import { connectFela } from '../../dependencies';
import Memberships from './Memberships';
import * as styles from './Memberships.styles';

export default connectFela(styles)(Memberships);
